<template>
    <div class="level-list">
        <div class="level-item frc">
            <div class="level-title">{{ courseLevel[0].name }}</div>
            <ul class="level-content frc">
                <template v-for="(mArrayItem, mArrayIndex) in courseLevel[0].mArray">
                    <li :key="mArrayIndex" v-bind:class="mArrayIndex == courseLevel[0].selected ? 'selected' : 'normal'" v-on:click="mArrayIndexTap(0, mArrayIndex)">{{ mArrayItem.architectureName }}</li>
                </template>
            </ul>
        </div>
        <div class="level-item frc" style="margin: 20px 0px">
            <div class="level-title">{{ courseLevel[1].name }}</div>
            <ul class="level-content frc">
                <template v-for="(mArrayItem, mArrayIndex) in courseLevel[1].mArray">
                    <li :key="mArrayIndex" v-bind:class="mArrayIndex == courseLevel[1].selected ? 'selected' : 'normal'" v-on:click="mArrayIndexTap(1, mArrayIndex)">{{ mArrayItem.classificationName }}</li>
                </template>
            </ul>
        </div>
        <div class="level-item frc">
            <div class="level-title">{{ courseLevel[2].name }}</div>
            <ul class="level-content frc">
                <template v-for="(mArrayItem, mArrayIndex) in courseLevel[2].mArray">
                    <li :key="mArrayIndex" v-bind:class="mArrayIndex == courseLevel[2].selected ? 'selected' : 'normal'" v-on:click="mArrayIndexTap(2, mArrayIndex)">{{ mArrayItem.difficultyName }}</li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    import Auth from "@/utils/Auth";

    export default {
        name: "MLevel",
        components: {},
        data() {
            return {

            };
        },
        computed: {
            courseLevel() {
                return this.$store.state.mlevel.courseLevel;
            },
            courseLevelIds() {
                return this.$store.state.mlevel.courseLevelIds;
            }
        },
        watch: {},
        mounted() {
            this.$store.dispatch("getLevelList");
        },
        methods: {
            mArrayIndexTap(courseLevelIndex, mArrayIndex) {
                if (courseLevelIndex === 0) {
                    this.courseLevelIds.architectureId = this.courseLevel[courseLevelIndex].mArray[mArrayIndex].architectureId;
                } else if (courseLevelIndex === 1) {
                    this.courseLevelIds.classificationId = this.courseLevel[courseLevelIndex].mArray[mArrayIndex].classificationId;
                } else if (courseLevelIndex === 2) {
                    this.courseLevelIds.difficultyId = this.courseLevel[courseLevelIndex].mArray[mArrayIndex].difficultyId;
                }
                this.$store.commit("setCourseLevelIds", this.courseLevelIds);
                this.$emit("curLevel");
                this.courseLevel[courseLevelIndex].selected = mArrayIndex;
            }
        }
    };
</script>

<style scoped lang="scss">
    .level-list{
        margin: 0px 0px 30px 0px;
        padding: 24px 18px 24px 18px;
        background-color: #F5F7FA;
        border: 1px solid #ebedf0;
        border-radius: 4px;
        .level-item{
            .level-title{
                width: 50px;
                min-width: 50px;
                color: #808080;
                font-size: 14px;
                text-align: center;
            }
            .level-content{
                flex-wrap: wrap;
                font-size: 14px;
                li{
                    margin: 0px 6px;
                    cursor: pointer;
                    padding: 2px 10px;
                    border-radius: 2px;
                }
                .normal{
                    color: #000000;
                }
                .selected{
                    color: #ffffff;
                    background-color: #005cff;
                }
            }
        }
    }
</style>
